import { render, staticRenderFns } from "./MTabs.vue?vue&type=template&id=e8e86e12"
import script from "./MTabs.vue?vue&type=script&lang=js"
export * from "./MTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports